/** Display helpers for ship_method rows (API includes `shipping_details` / trans). */

export type ShippingMethodDisplayRow = {
  refId: string;
  label: string;
  methodId: string;
};

export function pickShippingTrans(row: any): any {
  const raw = row?.shipping_details;
  return Array.isArray(raw) ? raw[0] : raw;
}

/**
 * Builds rows for UI radios: value = `refId` (matches `address.shipping_id` / `quotation.shipping_id`).
 * Handles `shipping_details` as object or array.
 *
 * IMPORTANT: Shipping method labels are **not** hardcoded here. We always prefer the API-provided `name`.
 * If the API name is missing, we fall back to showing the `ref_id` as a last resort (still not a hardcoded label).
 */
export function buildSortedShippingDisplayRows(apiData: unknown): ShippingMethodDisplayRow[] {
  const rows = Array.isArray(apiData) ? apiData : [];
  return rows
    .map((row: any) => {
      const d = pickShippingTrans(row);
      const refRaw = d?.ref_id ?? row?.ref_id;
      if (refRaw == null || String(refRaw).trim() === "") return null;
      const refId = String(refRaw).trim();
      const rawName = d?.name ?? row?.name;
      const id = row?.id;
      if (id == null) return null;
      const label = String(rawName ?? "").trim() || refId;
      return {
        refId,
        label,
        methodId: String(id),
      };
    })
    .filter(Boolean)
    .map(({ refId, label, methodId }: any) => ({ refId, label, methodId })) as ShippingMethodDisplayRow[];
}
